<template>
  <md-dialog :md-active="open" class="modalEdit__instructors modal-categories">
    <div class="w-100 position-fixed mobile-cancel">
      <span
class="material-icons close text-right"
@click="closeModal"
        >close</span
      >
    </div>
    <div class="body-modal-instructor modal-body">
      <div class="md-dialog-title text-left">
        <h3 class="text-bold">CREAR UNA CATEGORIA</h3>
      </div>
      <div class="form-instructor dialog-body">
        <div class="row">
          <div class="col-md-12">
            <base-input
              v-model="formData.title"
              name="name"
              placeholder="Coloca el nuevo nombre a"
            ></base-input>
          </div>
        </div>
        <div class="col-md-12 p-0 mt-2">
          <multiselect
            v-model="formData.categoryParent"
            :loading="isLoadingCategories"
            :options="getProductsCategories"
            :show-labels="false"
            class="border-0 select-config"
            label="title"
            placeholder="Selecciona una categoría padre"
            track-by="id"
          >
            <template #noOptions>La lista esta vacía</template>

            <template #option="props">
              <div class="option__desc">
                <span class="option__title">{{ `${props.option.title}` }}</span>

                <span
                  v-if="
                    props.values && props.values.length && !props.values.isOpen
                  "
                  class="multiselect__single"
                  >{{ props.values.length }} options selected</span
                >
              </div>
            </template>
            <template #noResult>
              <div>Sin resultados</div>
            </template>
          </multiselect>
        </div>
        <div class="col-md-12 px-0">
          <textarea
            v-model="formData.description"
            class="form-control mt-3"
            placeholder="Descripción"
            rows="10"
          ></textarea>
        </div>
        <div class="col-md-6">
          <md-field class="d-none">
            <label>Cambia la imagen de la categoria</label>
            <input
              id="file-input"
              accept="image/*"
              type="file"
              @change="uploadCategoryImage"
            />
          </md-field>
        </div>

        <div class="col-md-6">
          <md-field class="d-none">
            <label>Cambia la imagen principal de la categoria</label>
            <input
              id="file-input-seo"
              accept="image/*"
              type="file"
              @change="uploadSeoImage"
            />
          </md-field>
        </div>

        <div class="col-md-6">
          <md-field class="d-none">
            <label>Cambia el icono de la categoria</label>
            <input
              id="icon-input"
              accept="image/*"
              type="file"
              @change="uploadIcon"
            />
          </md-field>
        </div>

        <div class="row mt-2">
          <div class="col-sm-6 col-md-6">
            <label>Selecciona una imagen</label>
          </div>

          <div class="col-sm-6 col-md-6">
            <label>Selecciona un icono</label>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-sm-6 col-md-6">
            <div class="imageContainer">
              <img
                v-if="this.formData.categoryFile.url"
                :src="this.formData.categoryFile.url"
                alt="productImage"
                class="imageToUpload"
              />
              <img
                v-else
                alt="productImage"
                class="imageToUpload"
                src="@/assets/images/logo/placeholder.png"
              />
              <div class="textUploadImage" @click="openInputFile">
                <p>Sube la imagen del curso</p>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-6">
            <div class="imageContainer bg-dark">
              <img
                v-if="this.formData.categoryIconFile.url"
                :src="this.formData.categoryIconFile.url"
                alt="productImage"
                class="imageToUpload"
              />
              <img
                v-else
                alt="productImage"
                class="imageToUpload"
                src="@/assets/images/logo/placeholder.png"
              />
              <div class="textUploadImage" @click="openInputIcon">
                <p>Sube un icono</p>
              </div>
            </div>
          </div>
        </div>
        <div class="text-left my-3">
          <h3 class="text-bold">SEO</h3>
          <h4 class="text-bold">FOTO PRINCIPAL</h4>
        </div>
        <div class="col-md-6 mt-2 pl-0">
          <div class="imageContainer">
            <img
              v-if="this.formData.categorySeoFile.url"
              :src="this.formData.categorySeoFile.url"
              alt="productImage"
              class="imageToUpload"
            />
            <img
              v-else
              alt="productImage"
              class="imageToUpload"
              src="@/assets/images/logo/placeholder.png"
            />
            <div class="textUploadImage" @click="openInputFileSeo">
              <p>Sube la imagen principal</p>
            </div>
          </div>
        </div>
        <div class="text-left mt-3">
          <h4 class="text-bold mb-0">TITULO</h4>
        </div>
        <div class="col-md-12 px-0">
          <base-input
            v-model="formData.seoTitle"
            name="name"
            placeholder="Coloca el Titulo"
          ></base-input>
        </div>
        <div class="text-left mt-3">
          <h4 class="text-bold mb-0">DESCRIPCIÓN</h4>
        </div>
        <div class="col-md-12 px-0">
          <textarea
            v-model="formData.seoDescription"
            class="form-control mt-3"
            placeholder="Descripción"
            rows="10"
          ></textarea>
        </div>
        <md-dialog-actions class="modal-footer">
          <md-button
class="md-primary w-auto"
@click="closeModal"
            >CANCELAR
          </md-button>
          <base-button
            :loading="isLoading"
            class="md-primary w-auto"
            type="submit"
            @click="createCategory"
            >CREAR
          </base-button>
        </md-dialog-actions>
      </div>
    </div>
  </md-dialog>
</template>

<script>
import { CREATE_PRODUCT_CATEGORY } from '../../../../store/actions/products';
import { mapGetters } from 'vuex';
import BaseButton from '../../../../components/BaseButton';
import Multiselect from 'vue-multiselect';

export default {
  name: 'CreateProductCategoryDialog',
  components: {
    BaseButton,
    Multiselect,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close-modal', 'success'],
  data() {
    return {
      formData: {
        title: '',
        description: '',
        categoryFile: {
          url: '',
        },
        categoryIconFile: {
          url: '',
        },
        categorySeoFile: {
          url: '',
        },
        seoTitle: '',
        seoDescription: '',
        categoryParent: '',
      },
      isLoading: false,
      isLoadingCourses: true,
      categoryIconFile: undefined,
      categoryImageFile: undefined,
      categorySeoImageFile: undefined,
      categoryParents: [],
      isLoadingCategories: true,
    };
  },
  computed: {
    ...mapGetters(['getProductsCategories']),
    open: {
      // getter
      get: function () {
        return this.isOpen;
      },
      // setter
      set: function () {
        this.closeModal();
      },
    },
  },
  mounted() {
    // Fetch categories from API
    this.isLoadingCategories = false;
  },
  methods: {
    validateCategoryProductForm() {
      const errors = [];

      if (!this.formData.title) errors.push('El titulo es requerido');
      if (!this.formData.description)
        errors.push('La Descripción es requerido');

      return errors;
    },
    notify(type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
    closeModal() {
      this.reset();
      this.$emit('close-modal');
    },
    reset() {
      this.formData = {
        title: '',
        description: '',
        categoryFile: {
          url: '',
        },
        categoryIconFile: {
          url: '',
        },
        categorySeoFile: {
          url: '',
        },
        seoTitle: '',
        seoDescription: '',
        categoryParent: '',
      };
      this.categoryIconFile = undefined;
      this.categoryImageFile = undefined;
      this.categorySeoImageFile = undefined;
    },
    createCategory() {
      const errors = this.validateCategoryProductForm();
      if (errors.length) return this.notify('danger', errors.join('<br/>'));

      const data = new FormData();
      data.append('title', this.formData.title ?? '');
      data.append('description', this.formData.description ?? '');
      data.append('seo_title', this.formData.seoTitle ?? '');
      data.append('seo_description', this.formData.seoDescription ?? '');
      data.append('category_parent', this.formData.categoryParent.id ?? '');

      if (this.iconFile) {
        data.append('product_category_icon_file', this.iconFile);
      }

      if (this.categoryImageFile) {
        data.append('product_category_file', this.categoryImageFile);
      }

      if (this.categorySeoImageFile) {
        data.append('product_category_seo_file', this.categorySeoImageFile);
      }

      this.isLoading = true;

      this.$store
        .dispatch(CREATE_PRODUCT_CATEGORY, data)
        .then(() => {
          this.notify('success', 'Se ha creado la categoria correctamente');
          this.isLoading = false;
          this.$emit('success');
          this.$emit('close-modal');
          this.reset();
        })
        .catch(() => {
          this.notify('danger', 'Tenemos problemas para crear la categoria');
          this.isLoading = false;
        });
    },
    uploadIcon(event) {
      const files = event.target.files;
      this.formData.categoryIconFile.url = URL.createObjectURL(files[0]);
      this.iconFile = files[0];
    },
    uploadCategoryImage(event) {
      const files = event.target.files;

      this.formData.categoryFile.url = URL.createObjectURL(files[0]);
      this.categoryImageFile = files[0];
    },
    uploadSeoImage(event) {
      const files = event.target.files;
      this.formData.categorySeoFile.url = URL.createObjectURL(files[0]);
      this.categorySeoImageFile = files[0];
    },
    openInputFile() {
      document.getElementById('file-input').click();
    },
    openInputFileSeo() {
      document.getElementById('file-input-seo').click();
    },
    openInputIcon() {
      document.getElementById('icon-input').click();
    },
  },
};
</script>

<style scoped></style>
